import { render, staticRenderFns } from "./BuyProgress.vue?vue&type=template&id=5811b1bc&"
import script from "./BuyProgress.vue?vue&type=script&lang=js&"
export * from "./BuyProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports